import { authHeader, handleResponse } from "../helpers";
export const dashboardDetailService = {
  fetchDashboardData
};

async function fetchDashboardData(filter) {
  const { fromDate, toDate, roleName } = filter;
  const requestOptions = {
    method: "GET",
    headers: authHeader()
  };

  const response = await fetch(
    `${process.env.REACT_APP_API_URL}Dashboard/DashBoardCount?fromDate=${fromDate}&toDate=${toDate}&roleName=${roleName}`,
    requestOptions
  );
  return handleResponse(response);
}
